import { render, staticRenderFns } from "./valueAddedService.vue?vue&type=template&id=2e1c3a88&scoped=true"
import script from "./valueAddedService.vue?vue&type=script&lang=js"
export * from "./valueAddedService.vue?vue&type=script&lang=js"
import style0 from "./valueAddedService.vue?vue&type=style&index=0&id=2e1c3a88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c3a88",
  null
  
)

export default component.exports